// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3ys3s","loaderOuter":"PageOverlayLoader_loaderOuter__1bajb"};